var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-alert-component", on: { keydown: _vm.keymap } },
    [
      _c("div", { staticClass: "room-alert" }, [
        _c("div", { staticClass: "room-alert-header" }),
        _c("div", { staticClass: "room-alert-body" }, [
          _c("div", { staticClass: "alert-text-container" }, [
            _c("p", { staticClass: "alert-text title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c("p", {
              staticClass: "alert-text text",
              domProps: { innerHTML: _vm._s(_vm.text) },
            }),
            _vm.type === "input" || _vm.type === "checkbox"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "alert-input-container flex justify-center items-center",
                  },
                  [
                    _vm.type === "input"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputValue,
                              expression: "inputValue",
                            },
                          ],
                          ref: "input",
                          staticClass: "alert-input",
                          attrs: { type: "text", id: `alert_${_vm.type}` },
                          domProps: { value: _vm.inputValue },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.onClickOk.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.inputValue = $event.target.value
                            },
                          },
                        })
                      : _vm.type === "checkbox"
                      ? _c(
                          "GrmCheckbox",
                          {
                            attrs: { id: `alert_${_vm.type}` },
                            model: {
                              value: _vm.inputValue,
                              callback: function ($$v) {
                                _vm.inputValue = $$v
                              },
                              expression: "inputValue",
                            },
                          },
                          [_vm._v(_vm._s(this.typeDescription))]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "room-alert-footer" }, [
          _c("ul", { staticClass: "button-list" }, [
            !_vm.onlyOk
              ? _c(
                  "li",
                  { staticClass: "button-item" },
                  [
                    _c(
                      "VButton",
                      {
                        staticClass: "cancel",
                        on: { click: _vm.onClickCancel },
                      },
                      [_vm._v(_vm._s(_vm.cancelText))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "li",
              { staticClass: "button-item" },
              [
                _c("VButton", { ref: "ok", on: { click: _vm.onClickOk } }, [
                  _vm._v(_vm._s(_vm.okText)),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }